// lenisによる慣性スクロールの実装

import Lenis from "@studio-freight/lenis";

export class MomentumLenis {
  #lenis;

  constructor() {
    this.#lenis = new Lenis();

    // `raf`メソッドをクラスのメソッドとしてバインドし、直接requestAnimationFrameに渡す
    requestAnimationFrame(this.raf.bind(this));
  }

  raf = (time) => {
    this.#lenis.raf(time);
    // `raf`メソッドを再度requestAnimationFrameに渡す
    requestAnimationFrame(this.raf);
  };
}
